<!--
 *                        ::
 *                       :;J7, :,                        ::;7:
 *                       ,ivYi, ,                       ;LLLFS:
 *                       :iv7Yi                       :7ri;j5PL
 *                      ,:ivYLvr                    ,ivrrirrY2X,
 *                      :;r@Wwz.7r:                :ivu@kexianli.
 *                     :iL7::,:::iiirii:ii;::::,,irvF7rvvLujL7ur
 *                    ri::,:,::i:iiiiiii:i:irrv177JX7rYXqZEkvv17
 *                 ;i:, , ::::iirrririi:i:::iiir2XXvii;L8OGJr71i
 *               :,, ,,:   ,::ir@mingyi.irii:i:::j1jri7ZBOS7ivv,
 *                  ,::,    ::rv77iiiriii:iii:i::,rvLq@huhao.Li
 *              ,,      ,, ,:ir7ir::,:::i;ir:::i:i::rSGGYri712:
 *            :::  ,v7r:: ::rrv77:, ,, ,:i7rrii:::::, ir7ri7Lri
 *           ,     2OBBOi,iiir;r::        ,irriiii::,, ,iv7Luur:
 *         ,,     i78MBBi,:,:::,:,  :7FSL: ,iriii:::i::,,:rLqXv::
 *         :      iuMMP: :,:::,:ii;2GY7OBB0viiii:i:iii:i:::iJqL;::
 *        ,     ::::i   ,,,,, ::LuBBu BBBBBErii:i:i:i:i:i:i:r77ii
 *       ,       :       , ,,:::rruBZ1MBBqi, :,,,:::,::::::iiriri:
 *      ,               ,,,,::::i:  @arqiao.       ,:,, ,:::ii;i7:
 *     :,       rjujLYLi   ,,:::::,:::::::::,,   ,:i,:,,,,,::i:iii
 *     ::      BBBBBBBBB0,    ,,::: , ,:::::: ,      ,,,, ,,:::::::
 *     i,  ,  ,8BMMBBBBBBi     ,,:,,     ,,, , ,   , , , :,::ii::i::
 *     :      iZMOMOMBBM2::::::::::,,,,     ,,,,,,:,,,::::i:irr:i:::,
 *     i   ,,:;u0MBMOG1L:::i::::::  ,,,::,   ,,, ::::::i:i:iirii:i:i:
 *     :    ,iuUuuXUkFu7i:iii:i:::, :,:,: ::::::::i:i:::::iirr7iiri::
 *     :     :rk@Yizero.i:::::, ,:ii:::::::i:::::i::,::::iirrriiiri::,
 *      :      5BMBBBBBBSr:,::rv2kuii:::iii::,:i:,, , ,,:,:i@petermu.,
 *           , :r50EZ8MBBBBGOBBBZP7::::i::,:::::,: :,:,::i;rrririiii::
 *               :jujYY7LS0ujJL7r::,::i::,::::::::::::::iirirrrrrrr:ii:
 *            ,:  :@kevensun.:,:,,,::::i:i:::::,,::::::iir;ii;7v77;ii;i,
 *            ,,,     ,,:,::::::i:iiiii:i::::,, ::::iiiir@xingjief.r;7:i,
 *         , , ,,,:,,::::::::iiiiiiiiii:,:,:::::::::iiir;ri7vL77rrirri::
 *          :,, , ::::::::i:::i:::i:i::,,,,,:,::i:i:::iir;@Secbone.ii:::
 -->

<template>
  <div class="popup" style="background: #fff;">
    <div style="display: flex; justify-content: space-around; font-weight: 800">
      <div
        style="
          width: 200px;
          background-color: rgb(251 201 30);
          height: 150px;
          border-radius: 10px;
        "
      >
        <div style="display: flex; padding-top: 40px; padding-left: 16px">
          教师未完成总数:{{ dataTop.teacherNotOk }}
        </div>
        <div style="display: flex; padding-top: 20px; padding-left: 16px">
          教师已完成总数:{{ dataTop.teacherOk }}
        </div>

        <div style=" margin-left: 219px; margin-top: -93px;">
        <div
          style="
            width: 200px;
            background-color: rgb(233 149 150);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
          教师待提交:{{ dataTop.teacherDaiTiJiao }}
        </div>
        <div
          style="
            width: 200px;
            background-color: rgb(221 152 239);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
          教师被驳回:{{ dataTop.teacherBieBoHui }}
        </div>
        <div
          style="
            width: 200px;
            background-color: rgb(94 190 243);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
          学管审核中:{{ dataTop.xueguanshenhezhong }}
        </div>
      </div>


      </div>



      <div
        style="
          width: 200px;
          background-color: rgb(125 219 218);
          height: 150px;
          border-radius: 10px;
        "
      >
        <div style="display: flex; padding-top: 40px; padding-left: 16px">
          销售待完成总数:{{ dataTop.marketNotOk }}
        </div>
        <div style="display: flex; padding-top: 20px; padding-left: 16px">
          销售已完成总数:{{ dataTop.marketOk }}
        </div>
      </div>

    </div>
    <p class="popup_top" style="text-align: left; margin-top: 15px;"><i class="el-icon-warning"
        style="color: #0e99db; margin-right: 5px;"></i><span style="margin-right: 20px;">假期课计划</span>
    </p>
    <el-form class="demo-form-inline" label-width="100px">
      <!-- <el-form-item label="日期:">
        <el-date-picker type="date" placeholder="选择日期" v-model="obj.classFirstDate" style="width: 100%;"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item> -->


      <!-- <el-form-item label="学生姓名:">
        <el-select placeholder="请选择学生" v-model="obj.studentId" style="width:100%;" clearable filterable>
          <el-option v-for="item in studentArr" :key="item.id" :value="item.id" :label="item.realname">
          </el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="线下学员:">
        <el-select placeholder="请选择学生" v-model="obj1.studentId" style="width:100%;" clearable filterable>
          <el-option v-for="item in studentArr" :key="item.id" :value="item.id" :label="item.realname">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="规划学员:">
        <el-select placeholder="请选择学生" v-model="obj1.studentId1" style="width:100%;" clearable filterable>
          <el-option v-for="item in studentArr1" :key="item.id" :value="item.id" :label="item.realname">
          </el-option>
        </el-select>
      </el-form-item>



      <el-form-item label="假期课老师:">
        <el-select placeholder="请选择" v-model="obj.teacherId" style="width:100%;" clearable filterable>
          <el-option v-for="item in teacherArr" :key="item.id" :value="item.id" :label="item.realname">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="跟进助理:">
        <el-select placeholder="请选择" v-model="obj.assistantId" style="width:100%;" clearable filterable>
          <el-option v-for="item in teacherArrr" :key="item.id" :value="item.id" :label="item.realname">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="科目:">
        <el-select placeholder="请选择" v-model="obj.subject" style="width:100%;" clearable filterable>
          <el-option v-for="item in subjectArr" :key="item.id" :value="item.id" :label="item.categoryName">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="五次课计划教师完成情况:" label-width="200px">
        <el-select placeholder="请选择" v-model="obj.accomplish" style="width:100%;">
          <el-option v-for="item in planTeacher" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="审核状态:">
        <el-select placeholder="请选择" v-model="obj.auditStatus" style="width:100%;" clearable filterable>
          <el-option v-for="item in auditStatusArr" :key="item.value" :value="item.value" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="学生类型:">
          <el-select
            placeholder="请选择"
            v-model="obj.classType"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in marketArr_ss"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
       </el-form-item>

       <el-form-item label="假期课计划:">
        <el-select placeholder="请选择" v-model="obj.vacationType" style="width:100%;">
          <el-option v-for="item in vacationTypeArr" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="创建日期：">
        <el-date-picker
            v-model="Time_start_end"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
         </el-date-picker>
      </el-form-item> 


      <el-form-item label="销售完成情况:">
        <el-select placeholder="请选择" v-model="obj.marketSuccess" style="width:100%;">
          <el-option v-for="item in marketSuccessArr" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所在地域:" >
        <el-select v-model="obj.regionName" clearable filterable placeholder="请选择所在地域"  style="width: 100%;">
          <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"  :value="item.dictType"></el-option>
        </el-select>    
      </el-form-item>

      <el-form-item label="首节课日期：">
        <el-date-picker
            v-model="Time_start_start_end"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
         </el-date-picker>
      </el-form-item> 

      <el-form-item label="诊断师:" >
        <el-select v-model="obj.diagnoseTeacherId" clearable filterable placeholder="请选择诊断师"  style="width: 100%;">
          <el-option v-for="item in optionsListt111" :key="item.teacherId" :label="item.teacherName"  :value="item.teacherId"></el-option>
        </el-select>    
      </el-form-item>

      <el-form-item label="规划师:" >
        <el-select v-model="obj.projectTeacherId" clearable filterable placeholder="请选择规划师"  style="width: 100%;">
          <el-option v-for="item in optionsListt1111" :key="item.teacherId" :label="item.teacherName"  :value="item.teacherId"></el-option>
        </el-select>    
      </el-form-item>

      <el-form-item label="学科组:" >
        <el-select v-model="obj.SubjectGroup" clearable filterable placeholder="请选择学科组"  style="width: 100%;">
          <el-option v-for="item in SubjectGroupList" :key="item.teacherId" :label="item.teacherName"  :value="item.teacherId"></el-option>
        </el-select>    
      </el-form-item>



      <!-- <el-form-item label="首次课成功情况:" label-width="200px">
        <el-select placeholder="请选择" v-model="obj.success" style="width:100%;">
          <el-option v-for="item in firstClassState" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button type="primary" @click="searchBtn">搜索</el-button>
        <el-button type="primary" @click="clearBtn">清空</el-button>
        <el-button type="primary" @click="historyBtn">五次课历史记录</el-button>
      </el-form-item> -->
    </el-form>
    <p style="width: 98%;text-align: right;"><el-button type="primary" @click="searchBtn" size="small" class="btns" icon="el-icon-search">搜索</el-button>
      <el-button type="primary" @click="clearBtn" class="btns" size="small" icon="el-icon-close">清空</el-button>
      <!-- <el-button type="primary"  @click="downloadBtn" class="btns" size="small" icon="el-icon-download">导出</el-button > -->
      <!-- <el-button type="primary" @click="historyBtn" size="small" class="btns" icon="el-icon-tickets">五次课历史记录</el-button> -->
    </p>
    <el-table :data="tableData" height="500" stripe style="width: 99%; margin:20px auto; " border :header-cell-style="{
      background: '#fafafa',
      'text-align': 'center'
    }" :cell-style="{ 'text-align': 'center' }">
      <el-table-column prop="studentName" label="学生姓名">
      </el-table-column>
      <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
      <!-- <el-table-column prop="classFirstDate" label="首次课日期">
      </el-table-column> -->
      <el-table-column prop="teacherName" label="假期课教师" width="150px"></el-table-column>

      <el-table-column prop="diagnoseTeacherName" label="诊断师"> </el-table-column>
      <el-table-column prop="projectTeacherName" label="规划师"> </el-table-column>


      <el-table-column prop="assistantName" label="跟进助理"> </el-table-column>
      <el-table-column prop="subjectName" label="科目">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createTime.substring(0,10)}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="accomplish" label="五次课计划教师完成情况">
        <template slot-scope="scope">
          <span v-if="scope.row.accomplish == 1">未完成</span>
          <span v-else>已完成</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="url" label="完成情况截图" width="150">
          <template slot-scope="scope">
            <img v-if="scope.row.url" :src="scope.row.url" :alt="scope.row.url" style="width: 100%; height: 100%;">
          </template>
       </el-table-column> -->
      <el-table-column prop="auditStatus" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == -1">被驳回</span>
          <span v-if="scope.row.auditStatus == -2">待提交</span>
          <span v-if=" scope.row.auditStatus == 0">审核中</span>
          <span v-if=" scope.row.auditStatus == 1">已完成</span>
          <span v-if=" scope.row.auditStatus === 2">待确认</span>
        </template>
      </el-table-column>
      <el-table-column prop="classType" label="学生类型">
          <template slot-scope="scope">
            <span v-if="scope.row.classType == 1">规划</span>
            <span v-if="scope.row.classType == 2">线下</span>
            <span v-if="scope.row.classType == 3">纯补课</span>
          </template>
        </el-table-column>

      <el-table-column prop="vacationTypeName" label="假期课类型" width="150"> </el-table-column>
      <el-table-column prop="classFirstDate" label="首节课日期" width="150"> </el-table-column>
      <el-table-column prop="classDate" label="上课时间" width="150"> </el-table-column>

      <el-table-column label="假期课计划" width="150px">
        <template slot-scope="scope">
          <el-button type="text" @click="detail(scope.row.id, scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="审批详情">
        <template slot-scope="scope">
          <el-button type="text" @click="handleClickDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="classDate" label="上课时间">
      </el-table-column> -->
      <el-table-column prop="address" label="销售完成情况" width="250px">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.marketSuccess" @change="changeMarke(scope.row)">
            <el-radio :label="2">已完成</el-radio>
            <el-radio :label="1">未完成</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>

      <el-table-column prop="isDelay" width="200px" label="是否延迟提交假期课计划">
          <template slot-scope="scope">
            <span v-if="scope.row.isDelay === 0">未知</span>
            <span v-if="scope.row.isDelay === 1">否</span>
            <span v-if="scope.row.isDelay === 2">是</span>
          </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                  <div style="display: flex;justify-content: space-around;">
                      <el-button type="text" :disabled="scope.row.auditStatus !== 2"  @click="handleClickView('确认', scope.row)">家长确认</el-button>
                      <el-button type="text" :disabled="scope.row.auditStatus === -1 || scope.row.auditStatus === -2 || scope.row.auditStatus === 1"  @click="handleClickView('驳回', scope.row)">驳回</el-button>
                      <!-- <el-button type="text" v-else @click="handleClickView('驳回', scope.row)">驳回</el-button> -->
                  </div>
              </template>
      </el-table-column>

      <!-- <el-table-column prop="address" width="250px" label="首次课成功情况">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.success" @change="handleStateChange(scope.row)">
            <el-radio :label="0">未成功</el-radio>
            <el-radio :label="1">已成功</el-radio>
          </el-radio-group>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="obj.pageNo"
      :page-size="obj.pageSize" layout="total, prev, pager, next" :total="total">
    </el-pagination>
    <!-- 五次课历史记录 -->
    <el-dialog title="假期课历史记录" :visible.sync="firstClassIsshow" width="90%">
      <el-form class="demo-form-inline" label-width="100px">
        <!-- <el-form-item label="日期:">
        <el-date-picker type="date" placeholder="选择日期" v-model="obj.classFirstDate" style="width: 100%;"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item> -->
        <el-form-item label="学生姓名:">
          <el-select placeholder="请选择学生" filterable v-model="objBottom.studentId" style="width:100%;" clearable >
            <el-option v-for="item in studentArr" :key="item.id" :value="item.id" :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="假期课教师:">
          <el-select placeholder="请选择" filterable v-model="objBottom.teacherId" style="width:100%;" clearable >
            <el-option v-for="item in teacherArr" :key="item.id" :value="item.id" :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目:">
          <el-select placeholder="请选择" filterable v-model="objBottom.subject" style="width:100%;" clearable >
            <el-option v-for="item in subjectArr" :key="item.id" :value="item.id" :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学生类型:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.classType"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in marketArr_ss"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>

        

        <!-- <el-form-item label="五次课计划教师完成情况:" label-width="200px">
          <el-select placeholder="请选择" v-model="objBottom.accomplish" style="width:100%;">
            <el-option v-for="item in planTeacher" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="销售完成情况:">
          <el-select placeholder="请选择" v-model="marketSuccess" style="width:100%;">
            <el-option v-for="item in marketSuccessArr" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="审核状态:">
        <el-select placeholder="请选择" v-model="obj.auditStatus" style="width:100%;">
          <el-option v-for="item in auditStatusArr" :key="item.value" :value="item.value" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item> -->
        <!-- <el-form-item label="销售完成情况:">
        <el-select placeholder="请选择" v-model="obj.marketSuccess" style="width:100%;">
          <el-option v-for="item in marketSuccessArr" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item> -->
        <!-- <el-form-item label="首次课成功情况:" label-width="200px">
        <el-select placeholder="请选择" v-model="obj.success" style="width:100%;">
          <el-option v-for="item in firstClassState" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="searchBtns">搜索</el-button>
          <el-button type="primary" @click="clearBtns">清空</el-button>
        </el-form-item> -->
      </el-form>
      <p style="width: 98%;text-align: right;"><el-button type="primary" @click="searchBtns">搜索</el-button>
        <el-button type="primary" @click="clearBtns">清空</el-button>
      </p>
      <el-table :data="tableData1" stripe style="width: 99%; margin:20px auto; " border :header-cell-style="{
        background: '#fafafa',
        'text-align': 'center'
      }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="studentName" label="学生姓名">
        </el-table-column>
        <!-- <el-table-column prop="classFirstDate" label="首次课日期">
      </el-table-column> -->
        <el-table-column prop="teacherName" label="五次课教师">
        </el-table-column>
        <el-table-column prop="subjectName" label="科目">
        </el-table-column>
        <el-table-column prop="classType" label="学生类型">
          <template slot-scope="scope">
            <span v-if="scope.row.classType == 1">规划</span>
            <span v-if="scope.row.classType == 2">线下</span>
            <span v-if="scope.row.classType == 3">纯补课</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="accomplish" label="五次课计划教师完成情况">
          <template slot-scope="scope">
            <span v-if="scope.row.accomplish == 1">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="auditStatus" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == -1">驳回</span>
          <span v-if="scope.row.auditStatus == 0">提交</span>
          <span v-if="scope.row.auditStatus == 1">通过</span>
          <span v-if="scope.row.auditStatus == 2">完成</span>
          <span v-else></span>
        </template>
      </el-table-column> -->
        <el-table-column prop="url" label="完成情况截图">
          <template slot-scope="scope">
            <img  v-if="scope.row.url" :src="scope.row.url" :alt="scope.row.url" style="width: 100%; height: 100%;">
          </template>
        </el-table-column>
        <el-table-column label="假期课计划">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row.id, scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="classDate" label="上课时间">
      </el-table-column> -->
        <el-table-column label="销售完成情况">
          <template slot-scope="scope">
            <span v-if="scope.row.marketSuccess == 2">已完成</span>
            <span v-if="scope.row.marketSuccess == 1">未完成</span>
          </template>
        </el-table-column>
        <el-table-column label="是否延迟提交假期课计划">
          <template slot-scope="scope">
            <span v-if="scope.row.isDelay === 0">未知</span>
            <span v-if="scope.row.isDelay === 1">否</span>
            <span v-if="scope.row.isDelay === 2">是</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="address" width="250px" label="首次课成功情况">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.success" @change="handleStateChange(scope.row)">
            <el-radio :label="0">未成功</el-radio>
            <el-radio :label="1">已成功</el-radio>
          </el-radio-group>
        </template>
      </el-table-column> -->
      </el-table>
      <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="obj.pageNo"
        :page-size="obj.pageSize" layout="total, prev, pager, next" :total="total1">
      </el-pagination>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog title="详情" :visible.sync="detailDia" width="50%">
      <el-form label-width="100px">

        <el-form-item label="计划类别">
           <div style="text-align: start;"> {{vacationType}} </div>
        </el-form-item>

        <el-form-item label="假期课计划">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容" v-model="content">
          </el-input>
        </el-form-item>
        <el-form-item label="相关资料" style="text-align: left;">
          <ul style="list-style-type: none;">
            <li v-for="(item, index) in fileList" :key="index"><a :href="item.url" download="file">{{
              item.name }}</a></li>
          </ul>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDia = false">取 消</el-button>
        <el-button type="primary" @click="detailDia = false">确 定</el-button>
      </span>
    </el-dialog>



    <el-dialog title="请上传完成截图" :visible="screenshotShow" width="50%" @before-close="handlescreenshotCler">
            <el-upload
            class="avatar-uploader"
            ref="upload"
            action="#"
            :on-remove="handleRemove"
            :beforeUpload="beforeUpload"
            :file-list="fileLists"
            :http-request="handleUpload"
            :auto-upload="true"
            drag
            :limit="1"
            accept=".png,.jpg,.pdf">
            <img v-if="screenshot" :src="screenshot" style="width: 100%;height: 100%;" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

      <div  class="dialog-footer" style="margin-top: 100px;">
        <el-button @click="handlescreenshotCler" style="margin-right: 50px;">取 消</el-button>
        <el-button type="primary" @click="handlescreenshotSubmit">确 定</el-button>
      </div>


    </el-dialog>

     <el-dialog  title="详情"  :visible.sync="handleClickDetailShow" width="50%" :before-close="handleClickDetailClose">
       <div>
            <div style=" display: flex;">
              <div style="width: 10%;" >审批意见:</div>
              <div style="margin-left: 20px;width: 80%;text-align: start;" >{{handleClickDetailView}}</div>
            </div>
            <el-divider></el-divider>

            <div style=" display: flex;">
              <div style="width: 10%;" >预览图片:</div>
              <div style="margin-left: 20px;width: 80%;text-align: start;color:#007bff;" @click="handleUrls(handleClickDetailImg)">{{handleClickDetailImg}}</div>
            </div>
            <el-divider></el-divider>

        </div>
      </el-dialog>


      <el-dialog  title="驳回"  :visible.sync="inputAuditRemarkShow" width="50%" :before-close="handleinputAuditRemarkClose">
       <div>
            <div style=" display: flex;">
              <div style="width: 90px;" >驳回原因:</div>
              <el-input v-model="inputAuditRemark" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注" maxlength="300" show-word-limit></el-input>
            </div>
        </div>


        <div  class="dialog-footer" style="margin-top: 10px; text-align: end;">
          <el-button size="small" @click="handleinputAuditRemarkClose" style="margin-right: 10px;">取 消</el-button>
          <el-button type="primary" size="small"  @click="handleSbut">确 定</el-button>
        </div>

      </el-dialog>


  </div>
</template>

<script>
import { getList, getTeachers, changeFirstClass, getStudents, markeStatus, getSubject, getdeta, getStudentsType } from "@/api/fiveClassApi"
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { J } from '@fullcalendar/core/internal-common';
export default {
  data () {
    return {
      inputAuditRemark:'',
      inputAuditRemarkShow:false,
      vacationType:'暑假课',
      screenshotShow:false,
      screenshot:"",
      fileLists:[],
      Time_start_end:[],
      detailDia: false,
      content: '',
      tableData: [],//表格数据
      teacherArr: [],//所有老师
      teacherArrr:[],
      studentArr: [],//所有学生
      studentArr1: [],//所有学生
      subjectArr: [],//所有科目
      fileList: [],
      SubjectGroupList: [],
      firstClassIsshow: false,
      firstClassState: [{ value: 0, label: "未成功" }, { value: 1, label: '已成功' }],
      planTeacher: [{ value: 1, label: "未完成" }, { value: 2, label: '已完成' }],
      auditStatusArr: [{ value: 0, name: "审核中" }, { value: -1, name: "被驳回" },{value: -2, name: '待提交'},{ value: 1, name: '已完成' },{ value: 2, name: '待确认' }],
      // auditStatusArr: [{ value: 0, name: "审核中" }, { value: -1, name: "被驳回" }, { value: 1, name: '已完成' },{value: -2, name: '待提交'}],
      marketSuccessArr: [{ value: 1, label: "未完成" }, { value: 2, label: '已完成' }],
      vacationTypeArr: [{ value: 1, label: "暑假课" }, { value: 2, label: '寒假课' }],
      obj: {
        projectTeacherId:'',
        diagnoseTeacherId:'',
        vacationType:'',
        marketSuccess: '',//销售完成情况
        auditStatus: '',//审核状态
        accomplish: '',//首次课教师计划完成情况
        classFirstDate: '',//首次课日期 搜索框
        teacherId: '',//教师Id 搜索框
        subject: '',//科目  搜索框
        studentId: '',//学生Id 搜索框
        // studentId1: '',//学生Id 搜索框
        id: "",
        SubjectGroup: '',
        assistantId:'',
        // marketSuccess: null,
        remark: '',
        pageNo: 1,
        pageSize: 10,
        classType:"",
        planType:2,
      },
      obj1: {
        studentId:"",
        studentId1:""
      },
      marketSuccess: '',
      tableData1: [],
      objBottom: {
        marketSuccess: '',//销售完成情况
        auditStatus: '',//审核状态
        accomplish: '',//首次课教师计划完成情况
        classFirstDate: '',//首次课日期 搜索框
        teacherId: '',//教师Id 搜索框
        subject: '',//科目  搜索框
        studentId: '',//学生Id 搜索框
        id: "",
        // success: "",
        remark: '',
        pageNo: 1,
        pageSize: 10,
        classType:"",
        regionName:'',
      },
      total: 0,//总条数
      total1: 0,
      dataTop: {
        xueguanshenhezhong:0,
        teacherOk:0,
        teacherNotOk:0,
        teacherDaiTiJiao:0,
        teacherBieBoHui:0,
        marketOk:0,
        marketNotOk:0,
        firstOk:0,
        firstNotOk:0,
      },
      marketArr_ss:[
      { value: 1, label: "规划" },
      { value: 2, label: "线下" },
      { value: 3, label: "纯补课" },
      ],
      handleClickDetailShow: false,
      handleClickDetailImg:'',
      handleClickDetailView:'',

      rows:{},

      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

      Time_start_start_end: [],
      optionsListt111: [],
      optionsListt1111: [],
    }
  },
  created () {
    this.getStudent()
    this.getAllSubject()
    this.getTeacher()
    this.getListData()

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
  },
  mounted(){
    
    this.optionsListt1111 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
    this.optionsListt111 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))
    this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))
  },
  methods: {

    handleSbut(){

      if(this.inputAuditRemark){
          axios.post(`${apiBaseUrl}/fiveRecord/vacationPassThrough`, { auditRemark: this.inputAuditRemark ,buttonStatus: 2 ,auditId: JSON.parse(localStorage.getItem("admin")).id, id: this.rows.id  }, { headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
            if(res.data.code === 200){
                this.$message({ type:'success', message: res.data.message })
                this.inputAuditRemark = ''
                this.inputAuditRemarkShow = false
                this.getListData()
            }else{
                this.$message({ type:'error', message: res.data.message })
            }
          })
      }else{
        this.$message({ type:'warning', message:'请填写驳回原因~' })
      }
    },

    handleinputAuditRemarkClose(){
      this.inputAuditRemarkShow = false
      this.inputAuditRemark = ''
    },

    handleClickDetailClose(){
      this.handleClickDetailShow = false
    },
    handleClickDetail(row){
      let { picture, remark , auditRemark } = row
      this.handleClickDetailView = auditRemark ? auditRemark : ''
      this.handleClickDetailImg = picture
      this.handleClickDetailShow = true
    },
    //详情
    detail (id,row) {
      this.detailDia = true
      this.vacationType = row.vacationTypeName
      getdeta(id).then(res => {
        this.content = res.data.content
        this.fileList = res.data.urlList
      })
    },
    //获取所有科目
    getAllSubject () {
      getSubject().then(res => {
        this.subjectArr = res.data
      })
    },
    //获取所有老师
    getTeacher () {
      axios.get(`${apiBaseUrl}/schedule/assistantList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => { this.teacherArrr = response.data.data;  })
      getTeachers().then(res => {
        this.teacherArr = res.data
      })
    },
    //获取所有学生
    getStudent () {
      // getStudents().then(res => {
      //   this.studentArr = res.data
      // })

      getStudentsType(2).then(res => {
        this.studentArr = res.data
      })
      getStudentsType(1).then(_res => {
        this.studentArr1 = _res.data
      })

    },
    //获取表格数据
    getListData () {
      // this.obj.marketSuccess = 1
      // this.obj.startTime = this.Time_start_end[0]
      // this.obj.endTime = this.Time_start_end[1]

      this.obj.startTime = this.Time_start_end.length > 0 ? this.Time_start_end[0] : ""
      this.obj.endTime = this.Time_start_end.length > 0 ? this.Time_start_end[1] : ""

      this.obj.firstStartTime = this.Time_start_start_end.length > 0 ? this.Time_start_start_end[0] : ""
      this.obj.firstEndTime = this.Time_start_start_end.length > 0 ? this.Time_start_start_end[1] : ""

      // this.obj.studentIds = this.obj.studentId + ',' + this.obj.studentId1

      let studentIds = ""
      if(this.obj1.studentId){
        studentIds = this.obj1.studentId + ''
        if(this.obj1.studentId1){
          studentIds =  this.obj1.studentId + ',' + this.obj1.studentId1
        }
      }else{
        if(this.obj1.studentId1){
          studentIds = this.obj1.studentId1  + ''
        }
      }

      let obj = {}



      if(studentIds){
         obj.studentIds = studentIds
      }else{
         obj = {}
         this.obj.studentIds = ""
      }

      let data = {
        vacationType: this.obj.vacationType,
        marketSuccess: this.obj.marketSuccess,
        auditStatus: this.obj.auditStatus,
        accomplish: this.obj.accomplish,
        classFirstDate: this.obj.classFirstDate,
        teacherId: this.obj.teacherId,
        subject: this.obj.subject,
        studentId: this.obj.studentId,
        id: this.obj.id,
        assistantId: this.obj.assistantId,
        remark: this.obj.remark,
        pageNo: this.obj.pageNo,
        pageSize: this.obj.pageSize,
        classType: this.obj.classType,
        planType: this.obj.planType,
        regionName: this.obj.regionName || localStorage.getItem('cityTepy'),
        startTime: this.obj.startTime,
        endTime: this.obj.endTime,
        firstStartTime: this.obj.firstStartTime,
        firstEndTime: this.obj.firstEndTime,

        projectTeacherId: this.obj.projectTeacherId,
        diagnoseTeacherId: this.obj.diagnoseTeacherId,
        categoryIds: this.obj.SubjectGroup,
      }


      let datas = Object.assign(data,obj)
      

      getList(datas).then(res => {
        if(res.code == 200){
           this.$message.success('查询成功')
           this.tableData = res.data.page.records
           this.total = res.data.page.total
           this.dataTop = res.data;
        }else{
          this.$message.error(res.message)
        }
        // ==========================page===========>>>>>>>>>>
      })
    },
    getListData1 () {
      this.objBottom.marketSuccess = 2
      this.objBottom.startTime = this.Time_start_end[0]
      this.objBottom.endTime = this.Time_start_end[1]
      getList(this.objBottom).then(res => {
        this.tableData1 = res.data.page.records
        this.total1 = res.data.page.total
        // ==========================page===========>>>>>>>>>>
      })
    },
    //点击五次课历史记录
    historyBtn () {
      this.firstClassIsshow = true
      this.objBottom.marketSuccess = 2
      getList(this.objBottom).then(res => {
        this.tableData1 = res.data.page.records
        this.total1 = res.data.page.total
      })
    },
    //修改销售完成情况
    changeMarke (row) {
      
      if(row.auditStatus == -1 || row.auditStatus == -2){
         this.$message({message: '审核状态必须已完成',type: 'warning' });
         row.marketSuccess = 1
      }else{
        let type = row.marketSuccess
        this.$confirm('此操作将修改销售完成情况, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.screenshotShow = true
            this.screenshotRow = row
            // let data = {
            //   id: row.id,
            //   marketSuccess: row.marketSuccess
            // }
            // markeStatus(data).then(res => {
            //   if (res.code == 200) {
            //     this.$message.success(res.message)
            //   } else {
            //     this.$message.error(res.message)
            //   }
            //   this.getListData()
            // })
          }).catch(() => {
            row.marketSuccess = type == 1 ? 2 : 1
            this.$message({
              type: 'warning',
              message: '已取消'
            });
          });
      }

    },


    handleClickView(type,row){

      this.rows = row

      if(type === '确认'){
        axios.post(`${apiBaseUrl}/fiveRecord/vacationPassThrough`, { auditRemark: '' ,buttonStatus: 1,auditId: JSON.parse(localStorage.getItem("admin")).id, id: row.id  }, { headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
              if(res.data.code === 200){
                  this.getListData()
              }else{
                  this.$message({ type:'error', message: res.data.message })
              }
        })
      }else{
        this.inputAuditRemarkShow = true
      }

    },

    handlescreenshotSubmit(){
      this.screenshotShow = false
      let row = this.screenshotRow
      let data = {
        id: row.id,
        marketSuccess: row.marketSuccess,
        url:this.screenshot
      }
      markeStatus(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
        this.screenshot = ""
        this.fileLists = [];
        this.getListData()
      })
    },
    handlescreenshotCler(){
      this.screenshot = ""
      this.fileLists = [];
      this.tableData.forEach((itme)=>{
        if(itme.id == this.screenshotRow.id){
            itme.marketSuccess = 1
        }
      })

      this.screenshotShow = false
    },
    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },
    beforeUpload(file) {
      // 限制上传类型
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf"||
        this.getFileName(file.name) === ".jpg";
      //限制的上限为20M
      const max20M = file.size / 1024 / 1024 < 20;
      if (!fileExtensions) {
        this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {
        
        this.screenshot = res.url
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {
          
        });
      });
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;
      this.screenshot = ""
    },


    //清空按钮
    clearBtn () {
      this.obj.marketSuccess = ""
      this.obj.projectTeacherId = ""
      this.obj.diagnoseTeacherId = ""
      this.obj.SubjectGroup = ""

      this.obj.auditStatus = ""
      this.obj.accomplish = ""
      this.obj.classFirstDate = ""
      this.obj.teacherId = ""
      this.obj.studentId = ""
      this.obj.assistantId = ""
      // this.obj.studentId1 = ""
      this.obj.vacationType = ""

      this.obj1.studentId = ""
      this.obj1.studentId1 = ""

      this.obj.subject = ""
      this.obj.pageNo = 1
      this.obj.classType = ""
      this.Time_start_end = []
      this.Time_start_start_end = []

      this.obj.regionName =''
      this.getListData()
    },
    clearBtns () {
      this.objBottom.marketSuccess = ""
      this.objBottom.auditStatus = ""
      this.objBottom.accomplish = ""
      this.objBottom.classFirstDate = ""
      this.objBottom.teacherId = ""
      this.objBottom.studentId = ""
      this.objBottom.subject = ""
      this.objBottom.classType = ""
      this.success = ''
      this.objBottom.marketSuccess = 2
      this.objBottom.regionName = ""
      getList(this.objBottom).then(res => {
        this.tableData1 = res.data.page.records
        this.total = res.data.page.total
      })
    },
    //搜索按钮
    searchBtn () {
      this.obj.pageNo = 1
      this.getListData()
    },
    downloadBtn(){

      // this.obj.studentIds = this.obj.studentId + ',' + this.obj.studentId1


      let studentIds = ""
      if(this.obj1.studentId){
        studentIds = this.obj1.studentId + ''
        if(this.obj1.studentId1){
          studentIds =  this.obj1.studentId + ',' + this.obj1.studentId1
        }
      }else{
        if(this.obj1.studentId1){
          studentIds = this.obj1.studentId1  + ''
        }
      }



      let obj = {}



      if(studentIds){
         obj.studentIds = studentIds
      }else{
         obj = {}
      }

      let datas = Object.assign(this.obj,obj)


      axios.post(`${apiBaseUrl}/fiveRecord/excelFiveRecord`, datas, { responseType: "blob",


          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }

    }).then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel",});
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "假期课计划.xlsx";
          downloadLink.click();
      });
    },
    searchBtns () {
      this.objBottom.marketSuccess = 2
      getList(this.objBottom).then(res => {
        this.tableData1 = res.data.page.records
        this.total1 = res.data.page.total
      })
    },
    //分页
    handleSizeChange (v) {
      this.obj.pageSize = v;
      this.getListData();
    },
    handleCurrentChange (v) {
      this.obj.pageNo = v;
      this.getListData();
    },
    handleSizeChange1 (v) {
      this.objBottom.pageSize = v;
      this.getListData1();
    },
    handleCurrentChange1 (v) {
      this.objBottom.pageNo = v;
      this.getListData1();
    },

  },
}
</script>

<style scoped>
header {
  text-align: left;
}

.pending {
  text-align: left;
}

.pending p {
  font-size: 14px;
}

.pending_bottom {
  width: 100%;
  height: 140px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
}

.pending_item {
  width: 170px;
  height: 100px;
  border-radius: 10px;
}

.pending_item p {
  margin-top: 20px;
  margin-left: 25px;
}

.leave {
  background: linear-gradient(to right, #028bcf, #80d0f6);
}

.renew {
  background: linear-gradient(to right, #fdbe29, #fecf64);
}

.communication {
  background: linear-gradient(to right, #5d9656, #aac8a6);
}

.afterClass {
  background: linear-gradient(to right, #ff698a, #fe9f74);
}

.first {
  background: linear-gradient(to right, #d87ea3, #e3c5c6);
}

.classroom {
  background: linear-gradient(to right, #1da8aa, #94e0dd);
}

.issue {
  background: linear-gradient(to right, #f4ab56, #f6cd9e);
}

.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
  margin: 0 ;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.el-upload {
  border: 1px dashed #d9d9d9 !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.demo-form-inline .el-form-item {
  margin-right: 30px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .fiveLessons {
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.fiveLessons {
    width: 70% !important;
  }
}
.el-upload .el-upload--text{
  margin: 0 auto !important;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/HolidayClassPlan/HolidayClassPlan.vue